import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { loadMetaPixel, track } from "@/analytics/metaPixel";

/**
 * Loads the Meta Pixel once, then fires a PageView on every SPA route change.
 * Admin routes are excluded so internal usage doesn't pollute reports.
 * Must be rendered inside <BrowserRouter>.
 */
export default function MetaPixel() {
  const location = useLocation();
  const firstRender = useRef(true);

  useEffect(() => {
    loadMetaPixel();
  }, []);

  useEffect(() => {
    // The initial PageView is sent by loadMetaPixel(); skip the first effect run
    // to avoid a duplicate.
    const isFirst = firstRender.current;
    firstRender.current = false;
    if (location.pathname.startsWith("/admin")) return;
    if (isFirst) return;
    track("PageView", {
      page_path: `${location.pathname}${location.search}${location.hash}`,
    });
  }, [location]);

  return null;
}
